import { createClient } from '@supabase/supabase-js';
import type { User } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase env. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export function getOrganisationIdFromUser(user: User | null): number | null {
  if (!user?.app_metadata) return null;
  const orgId = user.app_metadata.organisation_id;
  return orgId != null ? Number(orgId) : null;
}

export type UserRole = 'editor' | 'viewer';

export function getUserRole(user: User | null): UserRole {
  return user?.app_metadata?.role === 'editor' ? 'editor' : 'viewer';
}
